/** Drops focus from a mouse-clicked button so window hotkeys (arrows, Enter, digits) keep working afterwards. */
export const blurAfterMouseClick = (event: React.MouseEvent<HTMLElement>): void => {
  if (event.detail === 0 || !(event.target instanceof HTMLElement)) return
  event.target.closest('button')?.blur()
}
